import styled from '@emotion/styled'
import { Divider, Grid, Paper } from '@mui/material'
import { breakpoints as bp } from 'shared/style/constants'
import { getPxAsRem } from 'shared/utils'

const breakpoints = {
    mobile: `${bp.sm}px`,
    tablet: `${bp.md}px`,
}

export const Container = styled(Grid)`
    display: flex;
`

export const Card = styled(Paper)`
    padding: ${getPxAsRem(16)};
`

export const TitleContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'marginBottom',
})<{ marginBottom?: string }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${({ marginBottom }) => marginBottom || getPxAsRem(24)};
`

export const EditButtonContainer = styled(Grid)`
    display: flex;
    gap: ${getPxAsRem(8)};

    .MuiCircularProgress-root {
        color: ${({ theme }) => theme.palette.greyscale.white};
    }
`

export const StyledContainer = styled(Container)`
    min-height: 100vh;
    padding: ${getPxAsRem(16, 24)};

    @media (min-width: ${breakpoints.mobile}) {
        padding-bottom: ${getPxAsRem(132)};
    }
`

export const SubtitleContainer = styled(Grid)`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const StyledDivider = styled(Divider)`
    margin: ${getPxAsRem(24, 0)};
`
